import { Checkbox, DatePicker, Input, Modal, Select } from 'antd';
import { SuffixIcon } from './SuffixIcon';
import NumberFormat from 'react-number-format';
import { getInvalidDates } from '@med-fe/util';
import { TagRenderer } from './TagRenderer';
import { get } from 'lodash';
import moment from 'moment';
const { Option } = Select;
const { RangePicker } = DatePicker;

export const formItemMap = (
  {
    type,
    data,
    onSelect,
    placeholder,
    mode,
    onFocus,
    options,
    onSearch,
    onPopupScroll,
    onChange,
    onClear,
    onKeyPress,
    onPaste,
    isLoading,
    allowClear,
    inputType,
    min,
    max,
    step,
    defaultValue,
    onBlur,
    allowDateClear = false,
    onConfirmVisible,
    isConfirmVisible = false,
    name,
  }: any,
  isDisabled = false
): any => {
  const memorizeDate = moment().format('YYYY-MM-DD');

  switch (type) {
    case 'date':
      return (
        <>
          <DatePicker
            disabled={isDisabled}
            format={'YYYY-MM-DD'}
            disabledDate={getInvalidDates}
            allowClear={allowDateClear}
            inputReadOnly
            onChange={(value) => {
              if (value === null && data !== null && onConfirmVisible) onConfirmVisible(true, name);
              else onSelect(value);
            }}
            value={data ? moment(data) : null}
          />
          <Modal
            title='Confirm Clear'
            visible={isConfirmVisible}
            onOk={() => {
              onSelect(null);
              onConfirmVisible(false, name);
            }}
            onCancel={() => onConfirmVisible(false, name)}
            okText='Yes, clear'
            cancelText='No'
          >
            <p>Are you sure you want to clear the date?</p>
          </Modal>
        </>
      );
    case 'daterange':
      return (
        <RangePicker
          disabled={isDisabled}
          format={'YYYY-MM-DD'}
          disabledDate={getInvalidDates}
          allowClear={allowClear}
          placeholder={placeholder}
          inputReadOnly
          defaultValue={defaultValue && [moment(memorizeDate)]}
        />
      );
    case 'select':
      return (
        <Select
          showSearch
          allowClear={allowClear}
          onClear={onClear}
          placeholder={placeholder}
          maxTagCount={'responsive'}
          mode={mode}
          tagRender={(props) => <TagRenderer {...props} />}
          onSelect={onSelect}
          onFocus={onFocus}
          onBlur={onSearch ? undefined : onFocus}
          suffixIcon={<SuffixIcon />}
          onSearch={onSearch}
          onPopupScroll={onPopupScroll}
          filterOption={onSearch ? false : () => true}
          loading={isLoading}
          disabled={isDisabled}
          {...(onPopupScroll && { listHeight: 150 })}
        >
          {(options || data).map((option) => {
            const key = options ? option.id : get(option, 'id', option[0]);
            const value = options ? option.value : get(option, 'name', option[1]);
            return (
              <Option key={key} value={key}>
                {value}
              </Option>
            );
          })}
        </Select>
      );
    case 'checkbox':
      return <Checkbox disabled={isDisabled} />;
    case 'phone-field':
      return (
        <NumberFormat
          format='###-###-####'
          mask='_'
          customInput={
            isDisabled
              ? (inputProps: any) => <Input {...inputProps} disabled={isDisabled} allowClear={allowClear} />
              : Input
          }
        />
      );
    default:
      return (
        <Input
          placeholder={placeholder}
          onKeyPress={onKeyPress}
          onPaste={onPaste}
          allowClear={allowClear}
          disabled={isDisabled}
          type={inputType}
          min={min}
          max={max}
          step={step}
          onBlur={onBlur}
        />
      );
  }
};
